import Swal from 'sweetalert2';

const getDefaultOptions = () => {
  const i18n = global.i18n;

  return {
    title: i18n.t('dialogs.default.title'),
    text: i18n.t('dialogs.default.description'),
    icon: 'warning',
    showCancelButton: true,
    cancelButtonText: i18n.t('dialogs.buttons.cancel'),
    confirmButtonText: i18n.t('dialogs.buttons.confirm'),
    confirmButtonColor: '#7930e2',
  };
};

const Alert = {
  confirm: options => Swal.fire({ ...getDefaultOptions(), ...options }),
  confirmDanger: options => Swal.fire({ ...getDefaultOptions(), confirmButtonColor: '#dc3545', ...options }),
};

export default Alert;
